// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__W1TTO","delete":"Button_delete__kJUWQ","warning":"Button_warning__a6NYp"};